import type { GenerateConstantType } from "src/types/utility";
import { trackEvent } from "../utils/track-event";
import type { TrackingEvent, TrackingEventResponse } from "../utils/types";

export const APP_DOWNLOAD_ORIGIN = {
  confirmationPage: "confirmation_page",
  footer: "footer",
} as const;

export const APP_DOWNLOAD_STORE = {
  appStore: "app_store",
  googlePlay: "google_play",
} as const;

export type AppDownloadOrigin = GenerateConstantType<
  typeof APP_DOWNLOAD_ORIGIN
>;

export type AppDownloadStore = GenerateConstantType<typeof APP_DOWNLOAD_STORE>;

type AppDownloadButtonClickedProps = {
  origin: AppDownloadOrigin;
  store: AppDownloadStore;
  destinationUrl: string;
};

export type AppDownloadButtonClickedEvent = TrackingEvent<
  "App Download Button Clicked",
  {
    origin: AppDownloadOrigin;
    store: AppDownloadStore;
    destination_url: string;
  }
>;

export async function trackAppDownloadButtonClickedEvent({
  origin,
  store,
  destinationUrl,
}: AppDownloadButtonClickedProps): TrackingEventResponse {
  return await trackEvent("App Download Button Clicked", {
    props: {
      origin,
      store,
      destination_url: destinationUrl,
    },
    withRequestSource: true,
  });
}
